var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.8,118.5c0-54.8,39.7-94.5,92.2-94.5s92.2,39.8,92.2,94.5c0,58.2-43.2,102.1-92.2,102.1 S147.8,176.7,147.8,118.5z M240,0c-66.2,0-116.2,51-116.2,118.5c0,69.6,52.1,126.1,116.2,126.1c64.1,0,116.2-56.6,116.2-126.1 C356.2,51,306.3,0,240,0z M439.6,456H40.4c1.3-53.2,19.1-91.8,49.3-117.8c32-27.5,81.6-43.8,150.3-43.8 c68.7,0,118.2,16.3,150.3,43.8C420.5,364.2,438.2,402.8,439.6,456z M16.3,462.5c0-123.9,79.4-192.1,223.7-192.1 c144.2,0,223.6,68.2,223.6,192.1c0,9.7-7.8,17.5-17.5,17.5H33.9C24.2,480,16.3,472.2,16.3,462.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticular);
export default __webpack_public_path__ + "static/media/particular.3e23b041.svg";
export { ForwardRef as ReactComponent };